export const CONFIRM_LABEL = "Confirm"
export const CANCEL_LABEL = "Cancel"
export const RESET_LABEL = "Reset"
export const DELETE_LABEL = "Delete"

export const DIALOGPOPUP_DELETE = {
    title: DELETE_LABEL,
    cr_text: 'Do you confirm that you want to delete this PN / PN Family?',
    ssi_cons_text: 'Do you confirm that you want to delete this Task?',
};
export const DIALOGPOPUP_RESET = {
    title: RESET_LABEL,
    cr_text: `Are you sure you want to reset the Component reliability section ?
    Any changes or additions made will be lost as resetting the full table content.
    Please confirm.`,
    ssi_text: `Are you sure you want to reset the SSI/MSI task section ?
    Any changes or additions made will be lost as resetting the full table content.
    Please confirm.`,
    cons_text: `Are you sure you want to reset the Consolidated  task section ?
    Any changes or additions made will be lost as resetting the full table content.
    Please confirm.`,
};
